// /data/freeCertificatesData.js

export const freeCertificatesData = [
  {
    id: 1,
    name: "Google Data Analytics Professional Certificate",
    provider: "Google",
    platform: "Coursera",
    category: "Data Science",
    level: "Beginner",
    duration: "6 months (10 hrs/week)",
    description: "Learn to clean, organize, analyze data with spreadsheets, SQL, and R programming. Prepare for data analyst roles.",
    certificateLink: "https://www.coursera.org/professional-certificates/google-data-analytics",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "1.2M+",
    icon: "📊",
    tags: ["Data Analytics", "SQL", "R", "Spreadsheets"]
  },
  {
    id: 2,
    name: "IBM Data Science Professional Certificate",
    provider: "IBM",
    platform: "Coursera",
    category: "Data Science",
    level: "Beginner",
    duration: "5 months (10 hrs/week)",
    description: "Master data science tools like Python, SQL, Jupyter, and build machine learning models. Includes multiple hands-on projects.",
    certificateLink: "https://www.coursera.org/professional-certificates/ibm-data-science",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "800K+",
    icon: "🧠",
    tags: ["Python", "Machine Learning", "SQL", "Jupyter"]
  },
  {
    id: 3,
    name: "Deep Learning Specialization",
    provider: "DeepLearning.AI",
    platform: "Coursera",
    category: "AI/ML",
    level: "Intermediate",
    duration: "3 months (8 hrs/week)",
    description: "Build and train deep neural networks, optimize hyperparameters, and implement convolutional and recurrent networks.",
    certificateLink: "https://www.coursera.org/specializations/deep-learning",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "1.5M+",
    icon: "🤖",
    tags: ["Neural Networks", "TensorFlow", "CNN", "RNN"]
  },
  {
    id: 4,
    name: "Harvard CS50: Introduction to Computer Science",
    provider: "Harvard University",
    platform: "edX",
    category: "Computer Science",
    level: "Beginner",
    duration: "11 weeks (10-20 hrs/week)",
    description: "Learn programming fundamentals with C, Python, SQL, JavaScript, and more. One of the most popular CS courses online.",
    certificateLink: "https://www.edx.org/course/cs50s-introduction-to-computer-science",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "3M+",
    icon: "💻",
    tags: ["C", "Python", "SQL", "JavaScript", "Algorithms"]
  },
  {
    id: 5,
    name: "Meta Front-End Developer Professional Certificate",
    provider: "Meta",
    platform: "Coursera",
    category: "Web Development",
    level: "Beginner",
    duration: "7 months (7 hrs/week)",
    description: "Master front-end development with React, HTML, CSS, JavaScript, and UI/UX design principles.",
    certificateLink: "https://www.coursera.org/professional-certificates/meta-front-end-developer",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "600K+",
    icon: "🎨",
    tags: ["React", "JavaScript", "HTML", "CSS", "UI/UX"]
  },
  {
    id: 6,
    name: "Google IT Support Professional Certificate",
    provider: "Google",
    platform: "Coursera",
    category: "IT & Cybersecurity",
    level: "Beginner",
    duration: "6 months (10 hrs/week)",
    description: "Learn IT support skills including troubleshooting, customer service, networking, operating systems, and security.",
    certificateLink: "https://www.coursera.org/professional-certificates/google-it-support",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "900K+",
    icon: "🖥️",
    tags: ["Networking", "OS", "Security", "Troubleshooting"]
  },
  {
    id: 7,
    name: "AWS Cloud Practitioner Essentials",
    provider: "Amazon Web Services",
    platform: "AWS Training",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "6 hours (self-paced)",
    description: "Understand AWS cloud concepts, core services, security, pricing, and architecture fundamentals.",
    certificateLink: "https://aws.amazon.com/training/digital/aws-cloud-practitioner-essentials/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.6,
    students: "2M+",
    icon: "☁️",
    tags: ["AWS", "Cloud", "Infrastructure"]
  },
  {
    id: 8,
    name: "Google Cloud Digital Leader",
    provider: "Google Cloud",
    platform: "Google Cloud Skills Boost",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "8 hours (self-paced)",
    description: "Learn cloud concepts, digital transformation strategies, and Google Cloud products and services.",
    certificateLink: "https://www.cloudskillsboost.google/course_templates/314",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.5,
    students: "500K+",
    icon: "☁️",
    tags: ["GCP", "Cloud Strategy", "Digital Transformation"]
  },
  {
    id: 9,
    name: "Meta Back-End Developer Professional Certificate",
    provider: "Meta",
    platform: "Coursera",
    category: "Web Development",
    level: "Beginner",
    duration: "8 months (6 hrs/week)",
    description: "Learn Python syntax, Linux commands, Git version control, and database structures using MySQL and Django framework.",
    certificateLink: "https://www.coursera.org/professional-certificates/meta-back-end-developer",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "200K+",
    icon: "⚙️",
    tags: ["Python", "Django", "SQL", "Git", "Backend"]
  },
  {
    id: 10,
    name: "Google Cybersecurity Professional Certificate",
    provider: "Google",
    platform: "Coursera",
    category: "IT & Cybersecurity",
    level: "Beginner",
    duration: "6 months (7 hrs/week)",
    description: "Gain hands-on skills in Python, Linux, SQL, SIEM tools (Splunk/Chronicle), and incident response mitigation.",
    certificateLink: "https://www.coursera.org/professional-certificates/google-cybersecurity",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "450K+",
    icon: "🛡️",
    tags: ["Cybersecurity", "Python", "Linux", "SIEM", "Network Security"]
  },
  {
    id: 11,
    name: "Microsoft Power BI Data Analyst Professional Certificate",
    provider: "Microsoft",
    platform: "Coursera",
    category: "Data Science",
    level: "Beginner",
    duration: "5 months (10 hrs/week)",
    description: "Master Power BI to clean, transform, and visualize data. Includes prep resources for the PL-300 Microsoft official exam.",
    certificateLink: "https://www.coursera.org/professional-certificates/microsoft-power-bi-data-analyst",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "150K+",
    icon: "📈",
    tags: ["Power BI", "Data Visualization", "DAX", "Business Intelligence"]
  },
  {
    id: 12,
    name: "Introduction to DevOps and Cloud Computing",
    provider: "IBM",
    platform: "Coursera",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "3 weeks (4 hrs/week)",
    description: "Understand agile methodologies, scrum framework, CI/CD pipelines, and cloud development practices.",
    certificateLink: "https://www.coursera.org/learn/introduction-to-devops-cloud-computing",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "120K+",
    icon: "♾️",
    tags: ["DevOps", "CI/CD", "Agile", "Cloud"]
  },
  {
    id: 13,
    name: "FreeCodeCamp Responsive Web Design",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Web Development",
    level: "Beginner",
    duration: "300 hours (self-paced)",
    description: "Learn HTML5, CSS3, Flexbox, CSS Grid, and responsive layout patterns by building structural web application portfolios.",
    certificateLink: "https://www.freecodecamp.org/learn/responsive-web-design/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "1M+",
    icon: "💻",
    tags: ["HTML", "CSS", "Responsive Design", "Flexbox"]
  },
  {
    id: 14,
    name: "Elements of AI",
    provider: "University of Helsinki",
    platform: "Elements of AI",
    category: "AI/ML",
    level: "Beginner",
    duration: "6 weeks (5 hrs/week)",
    description: "A non-technical introduction to artificial intelligence, machine learning math logic, neural networks, and societal impacts.",
    certificateLink: "https://www.elementsofai.com/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "1M+",
    icon: "💡",
    tags: ["AI Basics", "Machine Learning", "Ethics", "Logic"]
  },
  {
    id: 15,
    name: "Python for Everybody Specialization",
    provider: "University of Michigan",
    platform: "Coursera",
    category: "Computer Science",
    level: "Beginner",
    duration: "8 months (3 hrs/week)",
    description: "Learn fundamental programming concepts using Python, including data structures, networked application interfaces, and databases.",
    certificateLink: "https://www.coursera.org/specializations/python-ification",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "2.5M+",
    icon: "🐍",
    tags: ["Python", "Data Structures", "Web Scraping", "SQL"]
  },
  {
    id: 16,
    name: "FreeCodeCamp JavaScript Algorithms and Data Structures",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Computer Science",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Master JavaScript fundamentals, OOP, Functional Programming, and complex OOP algorithm challenges.",
    certificateLink: "https://www.freecodecamp.org/learn/javascript-algorithms-and-data-structures/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "850K+",
    icon: "🧮",
    tags: ["JavaScript", "Algorithms", "Data Structures", "OOP"]
  },
  {
    id: 17,
    name: "Introduction to Computer Science and Programming Using Python",
    provider: "MIT",
    platform: "edX",
    category: "Computer Science",
    level: "Beginner",
    duration: "9 weeks (14 hrs/week)",
    description: "An algorithmic focus on computation concepts, problem-solving, and structured computation using Python.",
    certificateLink: "https://www.edx.org/course/introduction-to-computer-science-and-programming-7",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "1.4M+",
    icon: "🏛️",
    tags: ["Python", "Algorithms", "Data Structures", "Math"]
  },
  {
    id: 18,
    name: "Machine Learning Zoomcamp",
    provider: "DataTalksClub",
    platform: "GitHub / Independent",
    category: "AI/ML",
    level: "Intermediate",
    duration: "4 months (10 hrs/week)",
    description: "Engineering-focused machine learning course targeting production code deployments, regression models, and deep learning setups.",
    certificateLink: "https://github.com/DataTalksClub/machine-learning-zoomcamp",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "40K+",
    icon: "🏕️",
    tags: ["Machine Learning", "Python", "Kubernetes", "Docker", "Flask"]
  },
  {
    id: 19,
    name: "IBM Cloud Computing Professional Certificate",
    provider: "IBM",
    platform: "Coursera",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "6 months (6 hrs/week)",
    description: "Gain dynamic operational knowledge of Cloud Architecture, containerization, microservices, Kubernetes, and Serverless.",
    certificateLink: "https://www.coursera.org/professional-certificates/ibm-cloud-computing-fundamentals",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "90K+",
    icon: "🌥️",
    tags: ["Cloud Architecture", "Containers", "Kubernetes", "DevOps"]
  },
  {
    id: 20,
    name: "Google Advanced Data Analytics Professional Certificate",
    provider: "Google",
    platform: "Coursera",
    category: "Data Science",
    level: "Advanced",
    duration: "6 months (8 hrs/week)",
    description: "Level up analytics routines with mathematical stats, predictive modeling, machine learning, and advanced Python frameworks.",
    certificateLink: "https://www.coursera.org/professional-certificates/google-advanced-data-analytics",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "210K+",
    icon: "📈",
    tags: ["Python", "Machine Learning", "Statistics", "Regression"]
  },
  {
    id: 21,
    name: "AI for Everyone",
    provider: "DeepLearning.AI",
    platform: "Coursera",
    category: "AI/ML",
    level: "Beginner",
    duration: "4 weeks (2 hrs/week)",
    description: "Non-technical foundation course detailing machine learning structures, data workflows, and organizational AI application strategies.",
    certificateLink: "https://www.coursera.org/learn/ai-for-everyone",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "1.1M+",
    icon: "🧠",
    tags: ["AI Strategy", "Machine Learning", "Data Literacy"]
  },
  {
    id: 22,
    name: "Cisco Networking Basics",
    provider: "Cisco",
    platform: "Network Academy",
    category: "IT & Cybersecurity",
    level: "Beginner",
    duration: "22 hours (self-paced)",
    description: "Learn practical network architectures, Cisco IOS basics, protocol routing operations, and IP structural subnet masks.",
    certificateLink: "https://www.netacad.com/courses/networking/networking-basics",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.7,
    students: "500K+",
    icon: "🔌",
    tags: ["Networking", "Cisco", "IP Addressing", "Routing"]
  },
  {
    id: 23,
    name: "Architecting with Google Compute Engine",
    provider: "Google Cloud",
    platform: "Coursera",
    category: "Cloud Computing",
    level: "Intermediate",
    duration: "3 months (7 hrs/week)",
    description: "Deep dive into GCP infrastructure, virtual private clouds, load balancing, system interconnectivity, and cloud operations.",
    certificateLink: "https://www.coursera.org/specializations/gcp-architecture",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "180K+",
    icon: "⚙️",
    tags: ["GCP", "Google Compute Engine", "Networking", "VPC"]
  },
  {
    id: 24,
    name: "FreeCodeCamp Front End Development Libraries",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Web Development",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Incorporate client-side libraries styling websites. Use Bootstrap, SASS, jQuery, React, and Redux systems.",
    certificateLink: "https://www.freecodecamp.org/learn/front-end-development-libraries/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "400K+",
    icon: "🧱",
    tags: ["React", "Redux", "SASS", "Bootstrap", "jQuery"]
  },
  {
    id: 25,
    name: "Introduction to Linux",
    provider: "The Linux Foundation",
    platform: "edX",
    category: "Computer Science",
    level: "Beginner",
    duration: "14 weeks (5-7 hrs/week)",
    description: "Develop operational knowledge of Linux operating systems distributions, command-line interfaces, and terminal tools.",
    certificateLink: "https://www.edx.org/course/introduction-to-linux",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "1.3M+",
    icon: "🐧",
    tags: ["Linux", "Bash", "Command Line", "OS Fundamentals"]
  },
  {
    id: 26,
    name: "Scrimba Frontend Developer Career Path",
    provider: "Scrimba",
    platform: "Scrimba",
    category: "Web Development",
    level: "Beginner",
    duration: "6 months (15 hrs/week)",
    description: "Interactive screencast lessons detailing HTML, CSS, JavaScript, React, and portfolio optimization for jobs.",
    certificateLink: "https://scrimba.com/learn/frontend",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "300K+",
    icon: "🎬",
    tags: ["HTML", "CSS", "JavaScript", "React", "Interactive"]
  },
  {
    id: 27,
    name: "Foundations of Project Management",
    provider: "Google",
    platform: "Coursera",
    category: "Software Engineering",
    level: "Beginner",
    duration: "1 month (10 hrs/week)",
    description: "Understand methodologies like Agile, Scrum, and traditional Waterfall frameworks. Master project documentation tracking.",
    certificateLink: "https://www.coursera.org/learn/project-management-foundations",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "650K+",
    icon: "📅",
    tags: ["Project Management", "Agile", "Scrum", "Operations"]
  },
  {
    id: 28,
    name: "Data Engineering Zoomcamp",
    provider: "DataTalksClub",
    platform: "GitHub / Independent",
    category: "Data Science",
    level: "Advanced",
    duration: "9 weeks (12 hrs/week)",
    description: "Comprehensive data engineering lifecycle course featuring Docker, Terraform, Postgres, Airflow, Spark, and BigQuery infrastructure.",
    certificateLink: "https://github.com/DataTalksClub/data-engineering-zoomcamp",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "50K+",
    icon: "🚰",
    tags: ["Data Engineering", "Docker", "Terraform", "Spark", "Airflow"]
  },
  {
    id: 29,
    name: "AWS Certified Cloud Practitioner Ultimate Prep",
    provider: "FreeCodeCamp",
    platform: "YouTube / FreeCodeCamp",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "14 hours (self-paced)",
    description: "Full exam curriculum breakdown for the CLF-C02 certification covering billing,IAM policies, EC2, S3, and RDS.",
    certificateLink: "https://www.freecodecamp.org/news/aws-certified-cloud-practitioner-study-guide-clf-c02/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "800K+",
    icon: "⛅",
    tags: ["AWS", "Cloud Computing", "Exam Prep"]
  },
  {
    id: 30,
    name: "Python Data Structures",
    provider: "University of Michigan",
    platform: "Coursera",
    category: "Computer Science",
    level: "Beginner",
    duration: "5 weeks (3 hrs/week)",
    description: "Move past base syntax to learn data groupings using Lists, Dictionaries, and Tuples for advanced operations.",
    certificateLink: "https://www.coursera.org/learn/python-data",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "1.2M+",
    icon: "🗂️",
    tags: ["Python", "Data Structures", "Programming"]
  },
  {
    id: 31,
    name: "Harvard CS50X: Web Programming with Python and JavaScript",
    provider: "Harvard University",
    platform: "edX",
    category: "Web Development",
    level: "Intermediate",
    duration: "12 weeks (6-9 hrs/week)",
    description: "Deep dive design paradigms utilizing database APIs, security setups, Django models, and responsive user interfaces.",
    certificateLink: "https://www.edx.org/course/cs50s-web-programming-with-python-and-javascript",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "900K+",
    icon: "🕸️",
    tags: ["Django", "Python", "JavaScript", "SQL", "React"]
  },
  {
    id: 32,
    name: "Databases and SQL for Data Science with Python",
    provider: "IBM",
    platform: "Coursera",
    category: "Data Science",
    level: "Intermediate",
    duration: "4 weeks (6 hrs/week)",
    description: "Learn relational database structures, write DDL/DML statements, work with joins, and integrate SQL with Python Jupyter notebooks.",
    certificateLink: "https://www.coursera.org/learn/sql-data-science",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "410K+",
    icon: "🛢️",
    tags: ["SQL", "Relational Databases", "Python", "Data Science"]
  },
  {
    id: 33,
    name: "Stanford Machine Learning Specialization",
    provider: "Stanford University & DeepLearning.AI",
    platform: "Coursera",
    category: "AI/ML",
    level: "Beginner",
    duration: "2 months (10 hrs/week)",
    description: "Modernized version of Andrew Ng's world-famous ML course. Master supervised and unsupervised learning algorithms with Python.",
    certificateLink: "https://www.coursera.org/specializations/machine-learning-introduction",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "5M+",
    icon: "🎓",
    tags: ["Machine Learning", "Python", "Linear Regression", "Clustering"]
  },
  {
    id: 34,
    name: "FreeCodeCamp Data Visualization with D3",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Data Science",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Learn how to build interactive charts, graphs, map distributions, and hierarchical tree maps using D3.js and JSON schemas.",
    certificateLink: "https://www.freecodecamp.org/learn/data-visualization/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.7,
    students: "250K+",
    icon: "📊",
    tags: ["D3.js", "Data Visualization", "JavaScript", "JSON"]
  },
  {
    id: 35,
    name: "Neural Networks: Zero to Hero",
    provider: "Andrej Karpathy",
    platform: "YouTube / GitHub",
    category: "AI/ML",
    level: "Advanced",
    duration: "40 hours (self-paced)",
    description: "Build micrograd, language models, and GPT architectures completely from scratch using raw Python and PyTorch matrices.",
    certificateLink: "https://karpathy.ai/zero-to-hero.html",
    isFree: true,
    hasFinancialAid: false,
    rating: 5.0,
    students: "200K+",
    icon: "🦸",
    tags: ["PyTorch", "GPT", "Transformers", "Neural Networks"]
  },
  {
    id: 36,
    name: "Microsoft Azure Fundamentals (AZ-900) Study Path",
    provider: "Microsoft",
    platform: "Microsoft Learn",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "12 hours (self-paced)",
    description: "Core cloud concepts covering Azure architecture, governance models, storage modules, security parameters, and management tools.",
    certificateLink: "https://learn.microsoft.com/en-us/certifications/exams/az-900/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.6,
    students: "1.5M+",
    icon: "🔷",
    tags: ["Azure", "Cloud Computing", "AZ-900"]
  },
  {
    id: 37,
    name: "Introduction to Cybersecurity",
    provider: "Cisco",
    platform: "Network Academy",
    category: "IT & Cybersecurity",
    level: "Beginner",
    duration: "15 hours (self-paced)",
    description: "Explore data confidentiality, patterns of security exploits, risk remediation tactics, and enterprise defense measures.",
    certificateLink: "https://www.netacad.com/courses/cybersecurity/introduction-cybersecurity",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.7,
    students: "2M+",
    icon: "🔒",
    tags: ["Cybersecurity", "Network Defense", "Threat Analysis"]
  },
  {
    id: 38,
    name: "The Odin Project: Foundations",
    provider: "The Odin Project",
    platform: "TheOdinProject.org",
    category: "Web Development",
    level: "Beginner",
    duration: "2 months (self-paced)",
    description: "Open-source full-stack curriculum teaching Git workflows, text editor setups, HTML structural semantics, CSS styling, and introductory JavaScript.",
    certificateLink: "https://www.theodinproject.com/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "600K+",
    icon: "⛵",
    tags: ["Git", "HTML", "CSS", "JavaScript", "Linux"]
  },
  {
    id: 39,
    name: "Introduction to Git and GitHub",
    provider: "Google",
    platform: "Coursera",
    category: "Software Engineering",
    level: "Beginner",
    duration: "4 weeks (5 hrs/week)",
    description: "Learn version control strategies, undoing operations, code branch merging, remote repositories synchronization, and open-source contributions.",
    certificateLink: "https://www.coursera.org/learn/introduction-git-github",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "420K+",
    icon: "🐙",
    tags: ["Git", "GitHub", "Version Control", "DevOps"]
  },
  {
    id: 40,
    name: "FreeCodeCamp Relational Database Course",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Computer Science",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Interactive Linux terminal environment course covering complex Bash scripting, PostgreSQL database systems, and Git tracking pipelines.",
    certificateLink: "https://www.freecodecamp.org/learn/relational-database/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "180K+",
    icon: "🗄️",
    tags: ["PostgreSQL", "Bash", "SQL", "Linux Terminal"]
  },
  {
    id: 41,
    name: "Using Python to Access Web Data",
    provider: "University of Michigan",
    platform: "Coursera",
    category: "Computer Science",
    level: "Intermediate",
    duration: "4 weeks (4 hrs/week)",
    description: "Scrape web endpoints using BeautifulSoup, parse structured XML/JSON document layouts, and extract payloads from RESTful APIs.",
    certificateLink: "https://www.coursera.org/learn/python-network-data",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "850K+",
    icon: "🕷️",
    tags: ["Web Scraping", "Python", "APIs", "JSON", "BeautifulSoup"]
  },
  {
    id: 42,
    name: "Google Data Analytics Capstone",
    provider: "Google",
    platform: "Coursera",
    category: "Data Science",
    level: "Advanced",
    duration: "1 month (12 hrs/week)",
    description: "Complete a real-world case study project using Python/R, document code processes, design visual dashboards, and simulate data stakeholder presentations.",
    certificateLink: "https://www.coursera.org/learn/google-data-analytics-capstone",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "300K+",
    icon: "🎓",
    tags: ["Data Analytics", "Capstone", "R", "SQL", "Case Study"]
  },
  {
    id: 43,
    name: "Hugging Face Deep Reinforcement Learning Course",
    provider: "Hugging Face",
    platform: "Hugging Face",
    category: "AI/ML",
    level: "Advanced",
    duration: "2 months (8 hrs/week)",
    description: "Master Q-learning, Policy Gradients, and actor-critic networks using Stable-Baselines3 frameworks inside custom environments.",
    certificateLink: "https://huggingface.co/deep-rl-course",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "80K+",
    icon: "🤗",
    tags: ["Reinforcement Learning", "PyTorch", "Stable-Baselines3", "AI"]
  },
  {
    id: 44,
    name: "DevOps Zoomcamp",
    provider: "DataTalksClub",
    platform: "GitHub",
    category: "Cloud Computing",
    level: "Intermediate",
    duration: "3 months (10 hrs/week)",
    description: "Infrastructure automation engineering course highlighting provisioning, Ansible playbooks, Jenkins orchestration, and service tracking.",
    certificateLink: "https://github.com/DataTalksClub/devops-zoomcamp",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "25K+",
    icon: "🚀",
    tags: ["DevOps", "Terraform", "Ansible", "CI/CD", "Docker"]
  },
  {
    id: 45,
    name: "Harvard CS50P: Introduction to Programming with Python",
    provider: "Harvard University",
    platform: "edX",
    category: "Computer Science",
    level: "Beginner",
    duration: "10 weeks (9 hrs/week)",
    description: "A pythonic structural dive covering test automation processes with pytest, regex filtering, error checking, and text processing algorithms.",
    certificateLink: "https://www.edx.org/course/cs50s-introduction-to-programming-with-python",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "1M+",
    icon: "🐍",
    tags: ["Python", "Unit Testing", "Pytest", "Regex"]
  },
  {
    id: 46,
    name: "FreeCodeCamp Scientific Computing with Python",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Computer Science",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Develop structural programs using algorithmic computation models. Projects include arithmetic match engines and budget app objects.",
    certificateLink: "https://www.freecodecamp.org/learn/scientific-computing-with-python/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "320K+",
    icon: "🔬",
    tags: ["Python", "Algorithms", "Mathematical Computing"]
  },
  {
    id: 47,
    name: "Foundations of Digital Marketing and E-commerce",
    provider: "Google",
    platform: "Coursera",
    category: "Software Engineering",
    level: "Beginner",
    duration: "1 month (10 hrs/week)",
    description: "Understand structural SEO audits, marketing funnels, customer analytics metrics, and multi-channel campaign architectures.",
    certificateLink: "https://www.coursera.org/learn/foundations-of-digital-marketing-and-ecommerce",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "500K+",
    icon: "📈",
    tags: ["SEO", "Marketing Funnels", "Google Analytics", "E-commerce"]
  },
  {
    id: 48,
    name: "Introduction to Networks (CCNA v7)",
    provider: "Cisco",
    platform: "Network Academy",
    category: "IT & Cybersecurity",
    level: "Intermediate",
    duration: "70 hours (self-paced)",
    description: "First tier CCNA structural setup framework covering subnet operations, Ethernet media layers, physical architectures, and switch logic.",
    certificateLink: "https://www.netacad.com/courses/networking/ccna-introduction-networks",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "1.1M+",
    icon: "🕸️",
    tags: ["CCNA", "Networking", "Subnetting", "Ethernet"]
  },
  {
    id: 49,
    name: "Data Visualization with Python",
    provider: "IBM",
    platform: "Coursera",
    category: "Data Science",
    level: "Intermediate",
    duration: "3 weeks (6 hrs/week)",
    description: "Utilize Matplotlib layout styling, Seaborn relational data grids, and Folium geospatial mapping to synthesize visual intelligence data summaries.",
    certificateLink: "https://www.coursera.org/learn/python-for-data-visualization",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "220K+",
    icon: "📊",
    tags: ["Python", "Matplotlib", "Seaborn", "Folium", "Data Visualization"]
  },
  {
    id: 50,
    name: "Fast.ai Practical Deep Learning for Coders",
    provider: "Fast.ai",
    platform: "Fast.ai",
    category: "AI/ML",
    level: "Intermediate",
    duration: "7 weeks (12 hrs/week)",
    description: "Top-down approach code design using PyTorch and fastai wrappers. Train state-of-the-art vision, text, and tabular networks instantly.",
    certificateLink: "https://course.fast.ai/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "700K+",
    icon: "🚀",
    tags: ["Deep Learning", "PyTorch", "Computer Vision", "NLP"]
  },
  {
    id: 51,
    name: "Full Stack Open",
    provider: "University of Helsinki",
    platform: "Full Stack Open Portal",
    category: "Web Development",
    level: "Advanced",
    duration: "4 months (15 hrs/week)",
    description: "Rigorous full-stack application development course using React, Redux, Node.js, Express, MongoDB, GraphQL, and TypeScript environments.",
    certificateLink: "https://fullstackopen.com/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "450K+",
    icon: "🌐",
    tags: ["React", "Node.js", "GraphQL", "TypeScript", "MongoDB"]
  },
  {
    id: 52,
    name: "Google Cloud Engineering Professional Certificate",
    provider: "Google Cloud",
    platform: "Coursera",
    category: "Cloud Computing",
    level: "Intermediate",
    duration: "5 months (8 hrs/week)",
    description: "Prepare for Associate Cloud Engineer roles. Deploy resources, configure infrastructure networks, and manage identities across GCP.",
    certificateLink: "https://www.coursera.org/professional-certificates/gcp-cloud-engineering",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "190K+",
    icon: "☁️",
    tags: ["GCP", "Cloud Architecture", "Infrastructure", "IAM"]
  },
  {
    id: 53,
    name: "FreeCodeCamp Data Analysis with Python",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Data Science",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Read, filter, clean, and process multi-dimensional matrices using NumPy arrays, Pandas DataFrames, and structural data analytics models.",
    certificateLink: "https://www.freecodecamp.org/learn/data-analysis-with-python/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "340K+",
    icon: "🐼",
    tags: ["Pandas", "NumPy", "Python", "Data Analysis"]
  },
  {
    id: 54,
    name: "Software Engineering Virtual Experience",
    provider: "Goldman Sachs",
    platform: "Forage",
    category: "Software Engineering",
    level: "Intermediate",
    duration: "6 hours (self-paced)",
    description: "Simulate corporate developer jobs. Fix structural security leaks, optimize legacy password-hashing systems, and configure cloud environments.",
    certificateLink: "https://www.theforage.com/virtual-internships/prototype/ihb7vC569E9gS9Sjh/Goldman-Sachs-Engineering-Virtual-Experience",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.6,
    students: "100K+",
    icon: "🏦",
    tags: ["Cryptography", "Systems Architecture", "Corporate Simulation"]
  },
  {
    id: 55,
    name: "Harvard CS50AI: Introduction to Artificial Intelligence with Python",
    provider: "Harvard University",
    platform: "edX",
    category: "AI/ML",
    level: "Intermediate",
    duration: "7 weeks (10-15 hrs/week)",
    description: "Explore algorithmic graph searches, adversarial minimax setups, probabilistic data modeling networks, and NLP engines using Python.",
    certificateLink: "https://www.edx.org/course/cs50s-introduction-to-artificial-intelligence-with-python",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "540K+",
    icon: "🤖",
    tags: ["AI", "Search Algorithms", "Machine Learning", "NLP"]
  },
  {
    id: 56,
    name: "The Odin Project: Full Stack JavaScript",
    provider: "The Odin Project",
    platform: "TheOdinProject.org",
    category: "Web Development",
    level: "Advanced",
    duration: "5 months (self-paced)",
    description: "Master backend ecosystems completely using Node.js, Express routers, MongoDB schemas, deployment pipelines, and custom API builds.",
    certificateLink: "https://www.theodinproject.com/paths/full-stack-javascript",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "400K+",
    icon: "🦁",
    tags: ["Node.js", "Express", "MongoDB", "REST APIs", "React"]
  },
  {
    id: 57,
    name: "Introduction to Database Systems",
    provider: "Stanford University",
    platform: "Stanford Online",
    category: "Computer Science",
    level: "Advanced",
    duration: "8 weeks (10 hrs/week)",
    description: "Relational database algebra theories, relational constraints, query optimizations, XML schemas, and transactional ACID attributes.",
    certificateLink: "https://online.stanford.edu/courses/soe-ydatabases-databases",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "150K+",
    icon: "🗄️",
    tags: ["Database Theory", "SQL", "ACID", "Relational Algebra"]
  },
  {
    id: 58,
    name: "FreeCodeCamp Information Security",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "IT & Cybersecurity",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Build robust backend protection shields using Helmet.js, learn penetration validation scripts, and map structural hashing architectures.",
    certificateLink: "https://www.freecodecamp.org/learn/information-security/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "190K+",
    icon: "🛡️",
    tags: ["Helmet.js", "Node.js", "Penetration Testing", "Security"]
  },
  {
    id: 59,
    name: "AWS Developer Virtual Experience",
    provider: "Amazon Web Services",
    platform: "Forage",
    category: "Cloud Computing",
    level: "Intermediate",
    duration: "5 hours (self-paced)",
    description: "Simulate real-world cloud engineer tasks. Build container builds, format AWS Lambda logic templates, and track system latency profiles.",
    certificateLink: "https://www.theforage.com/virtual-internships/prototype/b6C7A8z8Z4XbYmK6n/AWS-Software-Engineering-Virtual-Experience",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.7,
    students: "120K+",
    icon: "☁️",
    tags: ["AWS Lambda", "Serverless", "Cloud Engineering"]
  },
  {
    id: 60,
    name: "Data Structures and Algorithms Specialization",
    provider: "UC San Diego",
    platform: "Coursera",
    category: "Computer Science",
    level: "Advanced",
    duration: "4 months (10 hrs/week)",
    description: "Master heavy foundational computational logic structures. Solve binary trees, sorting networks, hash tables, and dynamic programming.",
    certificateLink: "https://www.coursera.org/specializations/data-structures-algorithms",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "610K+",
    icon: "📐",
    tags: ["Algorithms", "Data Structures", "Dynamic Programming", "Graphs"]
  },
  {
    id: 61,
    name: "Machine Learning Engineering Zoomcamp",
    provider: "DataTalksClub",
    platform: "GitHub",
    category: "AI/ML",
    level: "Advanced",
    duration: "4 months (12 hrs/week)",
    description: "Transform ML models into robust web applications. Master model serialization, cloud deployment, and monitoring systems.",
    certificateLink: "https://github.com/DataTalksClub/mlops-zoomcamp",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "30K+",
    icon: "🏭",
    tags: ["MLOps", "Prefect", "MLflow", "Model Monitoring", "Kubernetes"]
  },
  {
    id: 62,
    name: "Google UX Design Professional Certificate",
    provider: "Google",
    platform: "Coursera",
    category: "Web Development",
    level: "Beginner",
    duration: "6 months (10 hrs/week)",
    description: "Master full design cycles. Create wireframes, interactive prototypes, user personas, and conduct comprehensive usability studies using Figma.",
    certificateLink: "https://www.coursera.org/professional-certificates/google-ux-design",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "1M+",
    icon: "🎨",
    tags: ["UX Design", "Figma", "Prototyping", "UI/UX"]
  },
  {
    id: 63,
    name: "FreeCodeCamp Machine Learning with Python",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "AI/ML",
    level: "Advanced",
    duration: "300 hours (self-paced)",
    description: "Train complex image classification models, recurrent sentence parsers, and neural estimators using TensorFlow pipelines.",
    certificateLink: "https://www.freecodecamp.org/learn/machine-learning-with-python/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "280K+",
    icon: "🤖",
    tags: ["TensorFlow", "Neural Networks", "Deep Learning", "Python"]
  },
  {
    id: 64,
    name: "Introduction to Git",
    provider: "GitHub",
    platform: "GitHub Skills",
    category: "Software Engineering",
    level: "Beginner",
    duration: "2 hours (self-paced)",
    description: "Official interactive bot-guided repository tutorial teaching merge conflict solutions, pull request patterns, and version branching.",
    certificateLink: "https://skills.github.com/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "1.5M+",
    icon: "🐙",
    tags: ["Git", "GitHub", "Version Control"]
  },
  {
    id: 65,
    name: "Microsoft Power Platform Fundamentals",
    provider: "Microsoft",
    platform: "Microsoft Learn",
    category: "Data Science",
    level: "Beginner",
    duration: "8 hours (self-paced)",
    description: "Learn to automate business workflows using Power Automate, analyze data with Power BI, and build basic apps with Power Apps.",
    certificateLink: "https://learn.microsoft.com/en-us/certifications/exams/pl-900/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.5,
    students: "400K+",
    icon: "⚡",
    tags: ["Power Platform", "Power Automate", "Power BI", "No-Code"]
  },
  {
    id: 66,
    name: "IBM Cybersecurity Analyst Professional Certificate",
    provider: "IBM",
    platform: "Coursera",
    category: "IT & Cybersecurity",
    level: "Beginner",
    duration: "8 months (6 hrs/week)",
    description: "Develop enterprise incident handling workflows. Master endpoint protection configurations, log analysis, and vulnerability scans.",
    certificateLink: "https://www.coursera.org/professional-certificates/ibm-cybersecurity-analyst",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "300K+",
    icon: "🛡️",
    tags: ["Cybersecurity", "Incident Response", "Vulnerability Assessment", "SIEM"]
  },
  {
    id: 67,
    name: "The Odin Project: NodeJS Course",
    provider: "The Odin Project",
    platform: "TheOdinProject.org",
    category: "Web Development",
    level: "Advanced",
    duration: "2 months (self-paced)",
    description: "Deep backend specialization covering server architectures, session authentications, passport configurations, and REST structural routers.",
    certificateLink: "https://www.theodinproject.com/paths/full-stack-javascript/courses/nodejs",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "220K+",
    icon: "🟢",
    tags: ["Node.js", "Express", "Authentication", "APIs"]
  },
  {
    id: 68,
    name: "Data Analysis with R Specialization",
    provider: "Duke University",
    platform: "Coursera",
    category: "Data Science",
    level: "Intermediate",
    duration: "4 months (6 hrs/week)",
    description: "Master exploratory data distributions using ggplot2, structural regression modeling configurations, and Bayesian inference algorithms.",
    certificateLink: "https://www.coursera.org/specializations/statistics",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "190K+",
    icon: "📊",
    tags: ["R Programming", "Statistics", "ggplot2", "Data Analysis"]
  },
  {
    id: 69,
    name: "Introduction to Cloud Computing",
    provider: "IBM",
    platform: "Coursera",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "3 weeks (4 hrs/week)",
    description: "Differentiate cloud deployment designs (IaaS, PaaS, SaaS). Understand native cloud storage patterns and hybrid environments.",
    certificateLink: "https://www.coursera.org/learn/introduction-to-cloud-computing",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "380K+",
    icon: "☁️",
    tags: ["Cloud Basics", "IaaS", "PaaS", "SaaS"]
  },
  {
    id: 70,
    name: "FreeCodeCamp Quality Assurance Course",
    provider: "FreeCodeCamp",
    platform: "freeCodeCamp.org",
    category: "Software Engineering",
    level: "Intermediate",
    duration: "300 hours (self-paced)",
    description: "Implement integration checking matrix setups using Chai, write node application server tests, and handle modular testing paradigms.",
    certificateLink: "https://www.freecodecamp.org/learn/quality-assurance/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "140K+",
    icon: "🧪",
    tags: ["Chai", "Mocha", "Unit Testing", "Quality Assurance"]
  },
  {
    id: 71,
    name: "Harvard CS50G: Introduction to Game Development",
    provider: "Harvard University",
    platform: "edX",
    category: "Computer Science",
    level: "Intermediate",
    duration: "12 weeks (9 hrs/week)",
    description: "Analyze structures of legendary titles. Master 2D/3D matrix graphics renderings using Unity structures and LÖVE2D code wrappers.",
    certificateLink: "https://www.edx.org/course/cs50s-introduction-to-game-development",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "380K+",
    icon: "🎮",
    tags: ["Game Dev", "Unity", "Lua", "C#", "LÖVE2D"]
  },
  {
    id: 72,
    name: "Google Cloud Associate Cloud Engineer Prep Course",
    provider: "Google Cloud",
    platform: "Google Cloud Skills Boost",
    category: "Cloud Computing",
    level: "Intermediate",
    duration: "40 hours (self-paced)",
    description: "Hands-on labs path focusing on gcloud CLI tools, resource monitoring metrics, and structural IAM network definitions.",
    certificateLink: "https://www.cloudskillsboost.google/paths/11",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.7,
    students: "300K+",
    icon: "☁️",
    tags: ["GCP", "Google Compute Engine", "Cloud Operations", "CLI"]
  },
  {
    id: 73,
    name: "Deep Learning Foundations",
    provider: "Google",
    platform: "Kaggle Learn",
    category: "AI/ML",
    level: "Intermediate",
    duration: "4 hours (self-paced)",
    description: "Build dense neural network layers, optimize dropouts, and manage validation steps with Keras and TensorFlow models.",
    certificateLink: "https://www.kaggle.com/learn/intro-to-deep-learning",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "400K+",
    icon: "🧠",
    tags: ["TensorFlow", "Keras", "Deep Learning", "Neural Networks"]
  },
  {
    id: 74,
    name: "IBM DevSecOps Professional Certificate",
    provider: "IBM",
    platform: "Coursera",
    category: "Cloud Computing",
    level: "Advanced",
    duration: "4 months (8 hrs/week)",
    description: "Inject automated security guardrails directly into CI/CD build environments. Use Tekton pipelines and vulnerability scanners.",
    certificateLink: "https://www.coursera.org/professional-certificates/ibm-devsecops",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "45K+",
    icon: "🛡️",
    tags: ["DevSecOps", "CI/CD", "Application Security", "Tekton"]
  },
  {
    id: 75,
    name: "FreeCodeCamp Data Structures and Algorithms Video Course",
    provider: "FreeCodeCamp",
    platform: "YouTube",
    category: "Computer Science",
    level: "Intermediate",
    duration: "8 hours (self-paced)",
    description: "Visual logic walkthrough analyzing sorting computations, linear array filtering, linked structural nodes, and recursive setups.",
    certificateLink: "https://www.youtube.com/watch?v=RBSGKlAvoiM",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "2M+",
    icon: "🧮",
    tags: ["Algorithms", "Data Structures", "Big O Notation"]
  },
  {
    id: 76,
    name: "Linux Security and Hardening",
    provider: "The Linux Foundation",
    platform: "edX",
    category: "IT & Cybersecurity",
    level: "Advanced",
    duration: "10 weeks (4 hrs/week)",
    description: "Secure production Linux kernels. Configure SSH defenses, firewall access paths, file permissions, and SELinux policies.",
    certificateLink: "https://www.edx.org/course/linux-security-fundamentals",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "110K+",
    icon: "🐧",
    tags: ["Linux Security", "SELinux", "Firewalls", "SSH Hardening"]
  },
  {
    id: 77,
    name: "Applied Data Science with Python Specialization",
    provider: "University of Michigan",
    platform: "Coursera",
    category: "Data Science",
    level: "Advanced",
    duration: "5 months (10 hrs/week)",
    description: "Master text data mining, graph-based network structures, and pandas algorithmic tracking utilities with Python.",
    certificateLink: "https://www.coursera.org/specializations/data-science-python",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "750K+",
    icon: "📊",
    tags: ["Python", "Text Mining", "Pandas", "Network Analysis"]
  },
  {
    id: 78,
    name: "Microsoft Azure Data Fundaments (DP-900)",
    provider: "Microsoft",
    platform: "Microsoft Learn",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "10 hours (self-paced)",
    description: "Core concepts of relational and non-relational database models on Azure, including Cosmos DB and Azure Synapse Analytics.",
    certificateLink: "https://learn.microsoft.com/en-us/certifications/exams/dp-900/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.6,
    students: "350K+",
    icon: "🔷",
    tags: ["Azure", "Azure SQL", "Cosmos DB", "Big Data"]
  },
  {
    id: 79,
    name: "Introduction to Computer Science using Java",
    provider: "Purdue University",
    platform: "edX",
    category: "Computer Science",
    level: "Beginner",
    duration: "6 weeks (6-8 hrs/week)",
    description: "Learn foundational object-oriented programming paradigms using Java. Master class structures, inheritance inheritance, and error loops.",
    certificateLink: "https://www.edx.org/course/java-programming-fundamentals",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "180K+",
    icon: "☕",
    tags: ["Java", "OOP", "Programming Basics"]
  },
  {
    id: 80,
    name: "Natural Language Processing Specialization",
    provider: "DeepLearning.AI",
    platform: "Coursera",
    category: "AI/ML",
    level: "Advanced",
    duration: "4 months (8 hrs/week)",
    description: "Build machine translation systems, attention networks, speech parsers, and custom BERT models from scratch.",
    certificateLink: "https://www.coursera.org/specializations/natural-language-processing",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "320K+",
    icon: "🗣️",
    tags: ["NLP", "Transformers", "BERT", "Attention Mechanisms"]
  },
  {
    id: 81,
    name: "The Odin Project: Advanced HTML and CSS",
    provider: "The Odin Project",
    platform: "TheOdinProject.org",
    category: "Web Development",
    level: "Advanced",
    duration: "1 month (self-paced)",
    description: "Master complex CSS layouts including custom CSS animations, SVG manipulation, typography, and advanced grid structures.",
    certificateLink: "https://www.theodinproject.com/paths/full-stack-javascript/courses/advanced-html-and-css",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "180K+",
    icon: "🎨",
    tags: ["CSS Grid", "Animations", "SVG", "Responsive Design"]
  },
  {
    id: 82,
    name: "Google Business Intelligence Professional Certificate",
    provider: "Google",
    platform: "Coursera",
    category: "Data Science",
    level: "Advanced",
    duration: "2 months (10 hrs/week)",
    description: "Learn how to build data pipelines, create BigQuery data schemas, and design visual tracking dashboards in Tableau.",
    certificateLink: "https://www.coursera.org/professional-certificates/google-business-intelligence",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "120K+",
    icon: "📊",
    tags: ["Tableau", "BigQuery", "ETL Pipelines", "Data Warehousing"]
  },
  {
    id: 83,
    name: "AWS Technical Essentials",
    provider: "Amazon Web Services",
    platform: "AWS Training",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "5 hours (self-paced)",
    description: "Deep dive into AWS products. Write security policies with IAM, spin up EC2 nodes, and construct private S3 storage buckets.",
    certificateLink: "https://aws.amazon.com/training/digital/aws-technical-essentials/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.7,
    students: "600K+",
    icon: "☁️",
    tags: ["AWS", "EC2", "S3", "IAM", "Serverless"]
  },
  {
    id: 84,
    name: "FreeCodeCamp Machine Learning Course with PyTorch",
    provider: "FreeCodeCamp",
    platform: "YouTube",
    category: "AI/ML",
    level: "Intermediate",
    duration: "25 hours (self-paced)",
    description: "Complete PyTorch handbook course covering tensor evaluations, linear regression optimization, and neural vision engines.",
    certificateLink: "https://www.youtube.com/watch?v=V_xro1bcAuA",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "500K+",
    icon: "🔥",
    tags: ["PyTorch", "Deep Learning", "Computer Vision", "Python"]
  },
  {
    id: 85,
    name: "Introduction to Software Engineering",
    provider: "IBM",
    platform: "Coursera",
    category: "Software Engineering",
    level: "Beginner",
    duration: "4 weeks (4 hrs/week)",
    description: "Software engineering lifecycles. Master modular architecture patterns, agile methodologies, and bug tracking configurations.",
    certificateLink: "https://www.coursera.org/learn/introduction-to-software-engineering",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "150K+",
    icon: "💻",
    tags: ["Software Engineering", "SDLC", "Agile", "Architecture"]
  },
  {
    id: 86,
    name: "Microsoft Security, Compliance, and Identity Fundamentals",
    provider: "Microsoft",
    platform: "Microsoft Learn",
    category: "IT & Cybersecurity",
    level: "Beginner",
    duration: "11 hours (self-paced)",
    description: "Learn identity access models across Azure Active Directory, compliance policies, and foundational security blueprints (SC-900).",
    certificateLink: "https://learn.microsoft.com/en-us/certifications/exams/sc-900/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.6,
    students: "290K+",
    icon: "🛡️",
    tags: ["Azure AD", "Cybersecurity", "Compliance", "SC-900"]
  },
  {
    id: 87,
    name: "Computer Vision Specialization",
    provider: "University at Buffalo",
    platform: "Coursera",
    category: "AI/ML",
    level: "Advanced",
    duration: "4 months (7 hrs/week)",
    description: "Master matrix image filters, edge matching tools, dense convolutional vision layers, and real-time object tracking patterns.",
    certificateLink: "https://www.coursera.org/specializations/computer-vision-transform-images-data",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "85K+",
    icon: "👁️",
    tags: ["Computer Vision", "OpenCV", "CNN", "Image Processing"]
  },
  {
    id: 88,
    name: "The Odin Project: React Course",
    provider: "The Odin Project",
    platform: "TheOdinProject.org",
    category: "Web Development",
    level: "Intermediate",
    duration: "1.5 months (self-paced)",
    description: "Deep dive into React architectures. Master hooks, component lifecycles, global context data trees, and automated testing.",
    certificateLink: "https://www.theodinproject.com/paths/full-stack-javascript/courses/react",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "240K+",
    icon: "⚛️",
    tags: ["React", "React Hooks", "Context API", "JavaScript"]
  },
  {
    id: 89,
    name: "Google Cloud Kubernetes Engine Architecture",
    provider: "Google Cloud",
    platform: "Coursera",
    category: "Cloud Computing",
    level: "Advanced",
    duration: "1 month (12 hrs/week)",
    description: "Build and deploy container applications to GKE. Master cluster scaling configs, network routing, and persistent pods.",
    certificateLink: "https://www.coursera.org/learn/google-kubernetes-engine",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "110K+",
    icon: "☸️",
    tags: ["Kubernetes", "GKE", "Docker", "Containers"]
  },
  {
    id: 90,
    name: "FreeCodeCamp Data Analysis with Python Video Course",
    provider: "FreeCodeCamp",
    platform: "YouTube",
    category: "Data Science",
    level: "Beginner",
    duration: "4 hours (self-paced)",
    description: "Learn data ingestion setups using Pandas, matrix computation arrays with NumPy, and custom statistical graphs.",
    certificateLink: "https://www.youtube.com/watch?v=r-uOLxNrNk8",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "650K+",
    icon: "📊",
    tags: ["Pandas", "NumPy", "Data Analysis", "Python"]
  },
  {
    id: 91,
    name: "Stanford Introduction to Databases (SQL)",
    provider: "Stanford University",
    platform: "edX",
    category: "Computer Science",
    level: "Intermediate",
    duration: "4 weeks (8 hrs/week)",
    description: "Master relational algebra theory, heavy relational constraints, complex window functions, and cross-table joins.",
    certificateLink: "https://www.edx.org/course/databases-5-sql",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.9,
    students: "200K+",
    icon: "🏛️",
    tags: ["SQL", "Relational Algebra", "Database Design"]
  },
  {
    id: 92,
    name: "Generative AI Fundamentals",
    provider: "Google Cloud",
    platform: "Google Cloud Skills Boost",
    category: "AI/ML",
    level: "Beginner",
    duration: "5 hours (self-paced)",
    description: "Understand Large Language Models (LLMs), attention mechanism concepts, and prompt design frameworks across Vertex AI.",
    certificateLink: "https://www.cloudskillsboost.google/course_templates/556",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.6,
    students: "800K+",
    icon: "✨",
    tags: ["Generative AI", "LLM", "Vertex AI", "Google Cloud"]
  },
  {
    id: 93,
    name: "FreeCodeCamp Front End Development Libraries Video Course",
    provider: "FreeCodeCamp",
    platform: "YouTube",
    category: "Web Development",
    level: "Intermediate",
    duration: "11 hours (self-paced)",
    description: "Video path building multi-component web single page application layouts using React, Redux, SASS modules, and Bootstrap layouts.",
    certificateLink: "https://www.youtube.com/watch?v=204aNEbMh7g",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "400K+",
    icon: "🎨",
    tags: ["React", "Redux", "SASS", "Bootstrap"]
  },
  {
    id: 94,
    name: "AWS Cloud Technical Essentials Video Masterclass",
    provider: "FreeCodeCamp",
    platform: "YouTube",
    category: "Cloud Computing",
    level: "Beginner",
    duration: "4 hours (self-paced)",
    description: "Visual architectural breakdown modeling EC2 scaling configurations, DynamoDB setups, and Route 53 DNS mappings.",
    certificateLink: "https://www.youtube.com/watch?v=3hLmDS179YE",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "300K+",
    icon: "☁️",
    tags: ["AWS", "Cloud Architecture", "EC2", "DynamoDB"]
  },
  {
    id: 95,
    name: "Python for Data Science and AI",
    provider: "IBM",
    platform: "Coursera",
    category: "Data Science",
    level: "Beginner",
    duration: "4 weeks (5 hrs/week)",
    description: "Learn foundational data science syntax. Cover file object reads, web api calls, and basic matrix operations using Pandas.",
    certificateLink: "https://www.coursera.org/learn/python-for-applied-data-science-ai",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "580K+",
    icon: "🐍",
    tags: ["Python", "Data Science", "Pandas", "NumPy"]
  },
  {
    id: 96,
    name: "Introduction to Agile Development and Scrum",
    provider: "IBM",
    platform: "Coursera",
    category: "Software Engineering",
    level: "Beginner",
    duration: "4 weeks (3 hrs/week)",
    description: "Master iterative project methodologies. Run sprint execution planning loops, build product backlogs, and track burn-down charts.",
    certificateLink: "https://www.coursera.org/learn/agile-development-scrum-for-devops",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.8,
    students: "190K+",
    icon: "🏃",
    tags: ["Agile", "Scrum", "DevOps", "Sprint Planning"]
  },
  {
    id: 97,
    name: "Generative AI for Developers",
    provider: "DeepLearning.AI",
    platform: "DeepLearning.AI Portal",
    category: "AI/ML",
    level: "Intermediate",
    duration: "10 hours (self-paced)",
    description: "Learn API engineering loops with LLMs. Build custom RAG retrieval databases, vector index trackers, and tool-agent architectures.",
    certificateLink: "https://www.deeplearning.ai/short-courses/chatgpt-prompt-engineering-for-developers/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.9,
    students: "1M+",
    icon: "🤖",
    tags: ["Prompt Engineering", "LLMs", "RAG", "LangChain"]
  },
  {
    id: 98,
    name: "Google Workspace IT Support Professional Certificate",
    provider: "Google",
    platform: "Coursera",
    category: "IT & Cybersecurity",
    level: "Beginner",
    duration: "2 months (8 hrs/week)",
    description: "Manage corporate SaaS identity suites. Configure domain routing mechanisms, access controls, and custom cloud integrations.",
    certificateLink: "https://www.coursera.org/professional-certificates/google-workspace-administration",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.7,
    students: "70K+",
    icon: "💼",
    tags: ["Google Workspace", "IT Support", "SaaS Admin"]
  },
  {
    id: 99,
    name: "Foundations of Software Testing",
    provider: "University of Minnesota",
    platform: "Coursera",
    category: "Software Engineering",
    level: "Intermediate",
    duration: "4 weeks (5 hrs/week)",
    description: "Master mutation checking configurations, boundary value verification configurations, and automated mock setups.",
    certificateLink: "https://www.coursera.org/learn/introduction-software-testing",
    isFree: true,
    hasFinancialAid: true,
    rating: 4.6,
    students: "80K+",
    icon: "🧪",
    tags: ["Software Testing", "Unit Testing", "Mutation Testing"]
  },
  {
    id: 100,
    name: "Deep Learning with PyTorch Foundation Course",
    provider: "Microsoft",
    platform: "Microsoft Learn",
    category: "AI/ML",
    level: "Intermediate",
    duration: "8 hours (self-paced)",
    description: "Official Microsoft path detailing neural network layers, deep text classifications, and tensor graph weights using PyTorch.",
    certificateLink: "https://learn.microsoft.com/en-us/training/paths/pytorch-fundamentals/",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.7,
    students: "150K+",
    icon: "🔥",
    tags: ["PyTorch", "Deep Learning", "Neural Networks"]
  },
  {
    id: 101,
    name: "Web Development Foundations: HTML & CSS Masterclass",
    provider: "Scrimba",
    platform: "Scrimba",
    category: "Web Development",
    level: "Beginner",
    duration: "15 hours (self-paced)",
    description: "Interactive browser terminal course teaching clean document layouts, Flexbox alignments, and styling methods.",
    certificateLink: "https://scrimba.com/learn/htmlcss",
    isFree: true,
    hasFinancialAid: false,
    rating: 4.8,
    students: "500K+",
    icon: "💻",
    tags: ["HTML", "CSS", "Flexbox", "Scrimba"]
  }
];

// Get unique categories
export const getCertCategories = () => {
  const categories = [...new Set(freeCertificatesData.map(cert => cert.category))];
  return categories.sort();
};

// Get stats
export const getCertStats = () => {
  return {
    total: freeCertificatesData.length,
    free: freeCertificatesData.filter(c => c.isFree).length,
    withFinancialAid: freeCertificatesData.filter(c => c.hasFinancialAid).length,
    categories: getCertCategories().length
  };
};